// extracted by mini-css-extract-plugin
export default {"arrowUp":"AccordionToogle_arrowUp__GJ2Ko","arrowDown":"AccordionToogle_arrowDown__XI3Ec"};